import { ChallanCard } from './ChallanCard';
import type { Challan } from '../../types';

interface ChallanListProps {
  challans: Challan[];
  selectedIds: string[];
  onToggle: (id: string) => void;
}

export function ChallanList({ challans, selectedIds, onToggle }: ChallanListProps) {
  return (
    <div className="flex flex-col gap-3 pb-4">
      {challans.map((challan) => (
        <ChallanCard
          key={challan.id}
          challan={challan}
          selected={selectedIds.includes(challan.id)}
          onToggle={() => onToggle(challan.id)}
          disabled={challan.status === 'paid'}
        />
      ))}
    </div>
  );
}
